export const iconFontAwesomeArrowsCircleChevronUp = (
	<i className="fa-solid fa-circle-chevron-up"></i>
);
